package com.patronat.top.features.dashboard.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository
import com.patronat.top.features.dashboard.domain.usecase.command.GetOwnerReviewsCommand

class GetOwnerReviewsUseCase(
    private val repository: ReviewModerationRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetOwnerReviewsCommand, DomainResult<ReviewListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetOwnerReviewsCommand): DomainResult<ReviewListResponse> {
        return repository.getMyVenueReviews(command.request)
    }
}
